
import React from 'react';
import '../Footer/_footer.scss';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <nav className="footer-nav">
                <a href="/terms">Terms of Service</a> | <a href="/privacy">Privacy Policy</a>
                </nav>
                <p className="footer-text">
                    Join our community to explore the fascinating world of books.
                </p>
                <p className="copyright">
                    &copy; {new Date().getFullYear()} Book Lovers Social Media. All rights reserved.
                </p>
            </div>
        </footer>
    );
}

export default Footer;


